// extracted by mini-css-extract-plugin
export default {"team":"team__1kFVy"};